import { environment } from './../../../environments/environment';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class TimeInterceptor implements HttpInterceptor {
  defaultTimeout: number;

  constructor(
    private navigationService: NavigationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isPlatformBrowser(this.platformId)) {
      return next.handle(req);
    }

    this.defaultTimeout = this.timeToTimeoutChecking(req);

    return next.handle(req).pipe(
      timeout(this.defaultTimeout),
      catchError(error => {
        if (error.name == 'TimeoutError') {
          // The loading interceptor releases this request in finalize.
          this.navigationService.navigate(['technical-error']);
        }
        return throwError(error);
      })
    );
  }

  timeToTimeoutChecking(req: HttpRequest<any>) {
    let timeoutTime = 15000;

    if (req.url.includes(environment.apis.order.CheckoutOrder) || req.url.includes(environment.apis.order.SubmitOrder)) {
      timeoutTime = 180000;
    }
    else if (req.url.includes(environment.apis.user.SendOTP) || req.url.includes(environment.apis.cart.RecalculateCart)) {
      timeoutTime = 30000;
    }

    return timeoutTime;
  }
}

